const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

// Returns the correct badge image URL.
// Uploaded badges are stored on the API; static badges are in the website build.
export const getBadgeUrl = (badgeID, uploaded = false) =>
    uploaded
        ? `${API_URL}/badges/${badgeID}.png`
        : `/img/frankBadges/${badgeID}.png`;
